<div ng-if="editor.isDesigning()" ng-show="isDragged" class="shadow"></div>
<c-form-element-actions ng-if="editor.isDesigning()" editor="editor" element="field"></c-form-element-actions>
<label ng-class="{selectable:editor.isDesigning()}" ng-mousedown="editor.dragBegin(field, $event)" title="{{(editor.isDesigning() ? 'move' : '')|translate}}" ng-bind-html="labelText"></label>
<span class="field-description" ng-bind-html="descriptionText"></span>
<div ng-if="!tool && editable" class="checkbox-row">
    <div ng-if="!field.List" class="info">{{'field.list.not.attached'|translate}}</div>
    <div ng-if="field.List && !fieldValue.Values.length" class="info">{{'field.list.empty'|translate}}</div>
    <div ng-repeat="option in fieldValue.Values | orderBy: 'option.FieldOption.Position' track by option.Id" class="checkbox">
        <c-checkbox checked="option.Done" label="option.FieldOption.Text|localize:language"/>
    </div>
</div>
<div ng-if="!tool && !editable" class="not-in-editmode checkbox-list">
    <div ng-if="!fieldValue.Values.length" style="font-style: italic;padding: 5px 0">{{'field.list.empty'|translate}}</div>
    <div ng-repeat="option in fieldValue.Values | orderBy: 'option.FieldOption.Position' track by option.Id">
        {{option.FieldOption.Text|localize:language}}
    </div>
</div>
<div ng-if="tool">
    <div><c-checkbox checked="false" label="'...'"></c-checkbox></div>
    <div><c-checkbox checked="false" label="'...'"></c-checkbox></div>
    <div><c-checkbox checked="false" label="'...'"></c-checkbox></div>
</div>